export const multiplication = (a, b) => {
    return a*b;
}
